// extracted by mini-css-extract-plugin
export default {"platform":"PlatformRouts_platform__MtCju"};